///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import PanelStateIndicator from "../PanelStateIndicator";
import messages from "../../../helpers/messages";
import addTitleForTruncatedText from "../../../helpers/addTitleForTruncatedText";
import TableHeader from "./shipper-history/TableHeader";
import TableBody from "./shipper-history/TableBody";

export const ShipperHistory = ({
  loading,
  error,
  fetchDetails,
  shipperHistory
}) => {
  const { user } = useSelector(state => state.user);
  const { division } = user;
  const headerTitle = shipperHistory?.shipperName
    ? `${messages.shipperHistory.defaultMessage} - ${shipperHistory.shipperName}`
    : messages.shipperHistory.defaultMessage;

  return (
    <div className="shipper-history mt-16 card pos-relative">
      <div
        className="border-bottom-grey card__heading--large pos-relative uppercase widget align-middle truncate header"
        data-testid="shipper-history-widget"
        onMouseEnter={e =>
          addTitleForTruncatedText(e.currentTarget, headerTitle)
        }
        onMouseLeave={e => (e.currentTarget.title = "")}
      >
        {headerTitle}
      </div>

      {(loading || error) && (
        <div className="p-40 box">
          <PanelStateIndicator
            loading={loading}
            error={error}
            handleRefresh={fetchDetails}
          />
        </div>
      )}

      {shipperHistory?.bidShipperHistories.length === 0 && (
        <div className="p-40 box items-center" data-testid="no-results-found">
          <p className="uppercase univers-45-light font-size-16 no-results-found">
            {messages.noResultsFound.defaultMessage}
          </p>
        </div>
      )}

      {shipperHistory?.bidShipperHistories.length > 0 && (
        <div style={{ height: 468 }} className="px-24 scroll scroll-on-hover">
          <table className="one-whole" data-testid="shipper-history-table">
            <TableHeader />
            <TableBody
              bids={shipperHistory.bidShipperHistories}
              division={division}
            />
          </table>
        </div>
      )}
    </div>
  );
};

export default ShipperHistory;
